module.exports = __webpack_public_path__ + "assets/img/Rules_btn.843fe2c1.png";